import { render, staticRenderFns } from "./WritingSlidePanel.vue?vue&type=template&id=2fbd1b1e&scoped=true&"
import script from "./WritingSlidePanel.vue?vue&type=script&lang=js&"
export * from "./WritingSlidePanel.vue?vue&type=script&lang=js&"
import style0 from "./WritingSlidePanel.vue?vue&type=style&index=0&id=2fbd1b1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd1b1e",
  null
  
)

export default component.exports